<button type="button" class="collapse-btn" mat-button (click)="toggleExpansion.emit()">
  <mat-icon *ngIf="isWide; else notWide"> arrow_left </mat-icon>
  <ng-template #notWide>
    <mat-icon>arrow_right</mat-icon>
  </ng-template>
</button>
